;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('notificationMenu', notificationMenu)

  /* @ngInject */
  function notificationMenu (NotificationsService, NotificationsCentralService) {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/core/directives/notification-menu/notification-menu-directive.html?$$REVISION$$',
      link: function ($scope, element, attributes) {
        $scope.unreadNotificationsCount = 0

        _getUnreadNotifications()

        const deregisterReloadUnreadNotifications = $scope.$on('reloadUnreadNotifications', function () {
          _getUnreadNotifications()
        })
        $scope.$on('$destroy', function () {
          deregisterReloadUnreadNotifications()
        })

        function _getUnreadNotifications () {
          NotificationsService.getUnreadNotificationsCount().then(res => {
            $scope.unreadNotificationsCount = res.count
          })
        }

        $scope.openNotificationsCentral = function () {
          NotificationsCentralService.open(true)
        }
      }
    }
  }
})()
